<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="about">
      <div class="main-content">
        <!-- title and content -->
        <div class="page-width pre-formatted padding">
          <div class="section-header text-center">
            <h2>{{ $t('companyInformationTitle') }}</h2>
          </div>
          <!-- <p v-html="$t('companyInformationBody')"></p> -->
        </div>
        <!-- image -->
        
        <div class="pre-formatted">
          <ul>
            <li>
              <img src="../../assets/img/warehouse1.png" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/warehouse2.png" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/warehouse3.png" alt=""/>
            </li>
            <li>
              <img src="../../assets/img/warehouse4.png" alt=""/>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';

export default {
  name: "about",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: this.$t('aboutUs'),
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/about.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/about.vue